export default {
  productService: '产品服务',
  businessContact: '商务联系',
  titleLabel: '为客户提供就近接入、集中管控、灵活扩容，安全可靠的上云体验，提供企业上云、分支组网，内网联通、应用加速等一站式的解决方案。',
  ZeroContact: '零接触部署',
  ZeroContactDetail: '网关设备插电联网，自动连接控制中心，实现分钟级上线完成网络部署，简化了用户的网络部署配置操作',
  IntelligentRoute: '智能选路',
  IntelligentRouteDetail: '基于实时网络探测质量数据，采用增强学习路由算法和AI技术，保障每次路由选择都为已探测线路中最优',
  WANOptimization: '广域网优化',
  WANOptimizationDetail: '支持智能压缩、TCP优化、UDP优化等，对网络包重新封装，提高网络性能，优化访问体验',
  UnifiedCloud: '云端统一管理',
  UnifiedCloudDetail: '流量监控、智能告警、访问控制、QOS策略、远程接入分支，对全网实时可视化监控，实现分支灵活运维管理'
}